import React, { useEffect, useState } from "react";
import appInsights from "../Config/appInsights";

const PageViewTracker = ({ pageName }) => {
  const [currentPath, setCurrentPath] = useState(window.location.pathname);

  useEffect(() => {
    const trackPageView = () => {
      const name = pageName || window.location.pathname;
      const traceName = `SutterSync ContentEngine-${name}`;
      setCurrentPath(name);
      let analyticsPlugin = appInsights.appInsights;
      if (analyticsPlugin) {
        analyticsPlugin.trackPageView({ name: traceName });
      } else {
        console.warn("Analytics plugin is not available.");
      }
    };

    const originalPushState = window.history.pushState;
    window.history.pushState = function (...args) {
      originalPushState.apply(window.history, args);
      // trackPageView();
    };

    // Track initial page load
    trackPageView();

    return () => {
      // window.removeEventListener("popstate", trackPageView);
      window.history.pushState = originalPushState;
    };
  }, [pageName]);

  return null; // This component does not render anything
};

export default PageViewTracker;